export default __webpack_public_path__ + "static/media/cycle_img.a7c54d95.webp";